export const STORE_TYPE_PARTNER = 2;

// CON-8186: Virtual Store (Caravel id=5, name="Virtual Store",
// rs_domain_name="Virtual Showroom") is a real store record with linked staff
// but isn't a physical showroom — it's promoted separately via the locator
// page's VirtualShowroomBlock and must never appear as a search result on the
// header, footer, mobile nav, or full locator page. Match on id first
// (stable) and fall back to name (in case id ever shifts upstream).
export const VIRTUAL_STORE_ID = 5;

export const isPhysicalShowroom = store => {
  if (!store) return false;
  if (store.id === VIRTUAL_STORE_ID) return false;
  if (store.name === 'Virtual Store' || store.name === 'Virtual Showroom') {
    return false;
  }
  return true;
};

export const BANNER_IMAGE_URL =
  'https://joybird2.imgix.net/public_img/static-v1/store-locator/storelocator-banner.jpg';

export const toStoreEntry = row => {
  if (!row) return null;
  if (row.storeData) {
    return {
      store: row.storeData,
      distance: typeof row.distance === 'number' ? row.distance : null,
    };
  }
  return { store: row, distance: null };
};

export const groupStoresByType = (stores = []) => {
  const showrooms = [];
  const partnerStudios = [];
  stores.forEach(store => {
    if (store?.type === STORE_TYPE_PARTNER) {
      partnerStudios.push(store);
    } else {
      showrooms.push(store);
    }
  });
  return { showrooms, partnerStudios };
};

export const groupStoresByState = (stores = []) => {
  const grouped = stores.reduce((acc, store) => {
    const state = store?.state || 'Other';
    if (!acc[state]) acc[state] = [];
    acc[state].push(store);
    return acc;
  }, {});

  return Object.keys(grouped)
    .sort()
    .reduce((acc, state) => {
      acc[state] = grouped[state]
        .slice()
        .sort((a, b) => (a?.name || '').localeCompare(b?.name || ''));
      return acc;
    }, {});
};

export const buildDirectionsUrl = store => {
  const parts = [store?.street, store?.city, store?.state, store?.zip].filter(
    Boolean
  );
  const destination = encodeURIComponent(parts.join(', '));
  return `https://www.google.com/maps/dir/?api=1&destination=${destination}`;
};

export const buildDetailUrl = store => {
  if (store?.slug) {
    return store.slug.startsWith('/') ? store.slug : `/${store.slug}`;
  }
  return '/showrooms/';
};
